function throttle<T extends any[]>(func: (...args: T) => void, limit: number): (...args: T) => void {
  let inThrottle: boolean = false;
  // eslint-disable-next-line func-names
  return function (this: any, ...args: T): void {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
}

export default throttle;
